
























import { defineComponent } from "@vue/composition-api";
import { capitalize } from "@/ts/functions/vueFilters";
import { useGetters } from "vuex-composition-helpers";
import { useInputRules } from "@/ts/functions/composition/inputRules";

export default defineComponent({
  name: "VisibilityInput",

  props: {
    value: {
      type: Number
    },
    type: {
      type: String
    }
  },

  setup(props, { emit, root }) {
    const rules = useInputRules();

    const { app_data } = useGetters({ app_data: "app/app_data" } as any);
    const visibilities = app_data.value.visibilities;

    const update = (visibility: number) => {
      emit("input", visibility);
    };

    return {
      visibilities,
      update,
      rules
    };
  }
});
